import { render } from "./TopicAiCrateView.vue?vue&type=template&id=fb835320&scoped=true"
import script from "./TopicAiCrateView.vue?vue&type=script&lang=js"
export * from "./TopicAiCrateView.vue?vue&type=script&lang=js"

import "./TopicAiCrateView.vue?vue&type=style&index=0&id=fb835320&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb835320"]])

export default __exports__